export default "__VITE_ASSET__40084088__"